


















import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import logger from '@plat-components/utils2/_esm5/logger'
const voice = {
  3: 1.6,
  6: 1.2,
  9: 1.2,
  10: 1.2,
  12: 1.6,
  13: 1.4,
  15: 2.2,
  19: 2.0,
  20: 1.6,
  21: 1.2,
  22: 1.6,
  25: 2.5,
  27: 1.6,
  29: 1.6,
}
@Component({})
export default class Item extends Vue {
  @State('currPoint') currPoint
  @Mutation('setAudioLoaded') setAudioLoaded

  playing = false
  audio: any = null
  @Watch('currPoint')
  watchCurrPointChange(newVal) {
    // 调整播放时间
    if (this.audio) {
      this.audio.pause()
      this.audio.currentTime = (newVal - 1) * 7
      console.log(
        '%c this.audio.currentTime ------> ',
        'color:#0f0;',
        (newVal - 1) * 7,
        this.audio.currentTime
      )
      this.audio.play()
      this.playing = true
    }
  }

  mounted() {
    this.audio = document.getElementById('bgMusic')
    let audioEle = this.audio
    audioEle.addEventListener('canplaythrough', () => {
      //监听audio是否加载完毕，如果加载完毕，则读取audio播放时间
      console.log('%c audio loaded ------> ', 'color:#0f0;')
      this.setAudioLoaded(true)
    })
    // alert(audioEle.load)
    // audioEle.load()
    this.listenVisibility()
  }

  listenVisibility() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.playing = false
        this.audio.pause()
      } else {
        // 回来继续播
        // this.audio.currentTime = (this.currPoint - 1) * 7
        // this.playing = true
        // this.audio.play()
      }
    })
  }

  play() {
    this.audio && this.audio.play()
    this.playing = true
  }

  handleEnded() {
    this.playing = false
  }

  // 控制播放进度
  handleTimeUpdate() {
    let currentTime = this.audio.currentTime
    let offset = voice[this.currPoint] || 0.8
    if (currentTime >= this.currPoint * 7 - offset) {
      this.audio && this.audio.pause()
      this.playing = false
    }
  }

  // 操作音乐
  toggleMusic() {
    if (this.audio) {
      if (this.audio.paused) {
        // 重置时间
        this.audio.currentTime = (this.currPoint - 1) * 7
        this.audio.play()
        this.playing = true
      } else {
        logger('follow_click', {
          periods: this.currPoint,
        })
        this.audio.pause()
        this.playing = false
      }
    }
  }
}
